import { t } from 'i18next'
import { Right } from 'src/assets'
import { Button, DatePicker, Form, Input } from 'src/components'
import { flightType, flightZodSchema } from 'src/types'
import { useIsMobile } from 'src/utils'

const FlightSection = ({ setState }: any) => {
  const isMobile = useIsMobile()
  const onSubmit = (value: flightType) => {
    const { departure } = value
    setState(departure)
    //to do add functionality when be is ready
  }
  return (
    <Form
      schema={flightZodSchema}
      onSubmit={onSubmit}
      className='w-full h-full flex-column gap-[20px]'
    >
      <div
        className={`w-full flex gap-[20px] ${isMobile ? 'flex-column' : ''}`}
      >
        <Input name='from' label={t('global.from')} />
        <Input name='to' label={t('global.to')} />
      </div>
      <div
        className={`w-full flex gap-[20px] ${isMobile ? 'flex-column' : ''}`}
      >
        {/* <Input
          className='w-full'
          name='departure'
          label={t('global.departure')}
        /> */}
        {/* <Input className='w-full' name='return' label={t('global.return')} /> */}
        <DatePicker
          className='w-full'
          name='departure'
          label={t('global.departure')}
        />
        <DatePicker
          className='w-full'
          name='return'
          label={t('global.return')}
        />
        <Input className='w-full' name='adults' label={t('global.adults')} />
        <Button
          icon={<Right />}
          className='min-h-[52px]'
          theme='secondary'
          type='submit'
        >
          {t('global.search')}
        </Button>
      </div>
    </Form>
  )
}

export default FlightSection
